/**
 * S-HTA-LEADSOURCE-ACTION-SPLIT-V1 (2026-05-31) — Frontend-Spiegelung.
 *
 * Kanonische Quelle: `backend/app/core/source_map.py`.
 * Synchronisiert via `GET /api/statistics/source-map` -> `hydrateSourceMap()`.
 *
 * Diese Datei haelt
 *   - Offline-Defaults fuer Boot/Vitest (must mirror backend at bundle time)
 *   - `hydrateSourceMap({ normalize, hide, action_normalize, action_hide })`
 *   - `resolveSourceLabel(value, mode)`     fuer Quelle 1 (Aufmerksamkeit)
 *   - `resolveActionLabel(value, mode)`     fuer Quelle 2 (gebuchte Aktion)
 *
 * Modi:
 *   'raw'       -> Rohwert 1:1 (null/undefined -> '')
 *   'display'   -> normalisiert; Unbekannte bleiben 1:1
 *   'canonical' -> wie display, aber hidden-Werte -> null
 */

// ── Bundled Offline-Defaults (Stand 2026-05-31) ──
const DEFAULT_NORMALIZE = {
  // S-HTA-LEADSOURCE-ACTION-SPLIT-V1 — Migration ALT -> NEU (Quelle 1)
  'Freunde': 'Freunde und Familie',
  'Familie': 'Freunde und Familie',
  'Beim Vorbeifahren / Standort gesehen': 'Beim Vorbeifahren',
  'Standort gesehen': 'Beim Vorbeifahren',
  // S-KUNDENQUELLEN-INTERNET-TO-GOOGLE-MERGE-V1 (2026-06): Internet == Google.
  'Internet': 'Google',
  'Internet / Social Media': 'Google',
  // S-KUNDENQUELLEN-WALKIN-TO-VORBEIFAHREN-MERGE-V1 (2026-06): Walk-in == Beim Vorbeifahren.
  'Walk-in': 'Beim Vorbeifahren',
  'Walk In': 'Beim Vorbeifahren',
  'Walkin': 'Beim Vorbeifahren',
  // S-KUNDENQUELLEN-EMPFEHLUNG-TO-FREUNDE-MERGE-V1 (2026-06): Empfehlung == Freunde und Familie.
  'Empfehlung': 'Freunde und Familie',
  // S-KUNDENQUELLEN-WEBSEITENGUTSCHEINE-TO-HOMEPAGE-MERGE-V1 (2026-06): nur source-Feld.
  'Webseiten-Gutscheine': 'Homepage Gutschein',
};

const DEFAULT_HIDE = [
  'excel_import',
  'altdaten_import_2016_2023',
  'Altsystem',
  'Test',
  'mitgliedliste_import',
  'Hauttypanalyse',
];

const DEFAULT_ACTION_NORMALIZE = {
  // S-HTA-LEADSOURCE-ACTION-SPLIT-V1 — Migration ALT -> NEU (Quelle 2)
  'Bestfriend': 'Best Friends',
  'Webseiten-Gutscheine': 'Gutscheine Webseite',
  'Bodyformer-Aktion': 'Bodyformer Aktion',
  '\u201ESchöne Beine\u201C-Aktion': 'Schöne Beine Aktion',
  'Schöne Beine': 'Schöne Beine Aktion',
  'EMP Chair Aktion': 'Beckenbodenprofi Aktion',
  'EMP-Share-Aktion': 'Beckenbodenprofi Aktion',
};

const DEFAULT_ACTION_HIDE = [
  'Keine',
];

// ── Laufzeit-Maps (mutable, von hydrateSourceMap ueberschreibbar) ──
let _normalize = { ...DEFAULT_NORMALIZE };
let _hide = new Set(DEFAULT_HIDE);
let _actionNormalize = { ...DEFAULT_ACTION_NORMALIZE };
let _actionHide = new Set(DEFAULT_ACTION_HIDE);
let _hydrated = false;

export function hydrateSourceMap(payload) {
  if (!payload || typeof payload !== 'object') return getSourceMapSnapshot();
  if (payload.normalize && typeof payload.normalize === 'object') {
    _normalize = { ...payload.normalize };
  }
  if (Array.isArray(payload.hide)) {
    _hide = new Set(payload.hide);
  }
  if (payload.action_normalize && typeof payload.action_normalize === 'object') {
    _actionNormalize = { ...payload.action_normalize };
  }
  if (Array.isArray(payload.action_hide)) {
    _actionHide = new Set(payload.action_hide);
  }
  _hydrated = true;
  return getSourceMapSnapshot();
}

export function _resetSourceMapForTests() {
  _normalize = { ...DEFAULT_NORMALIZE };
  _hide = new Set(DEFAULT_HIDE);
  _actionNormalize = { ...DEFAULT_ACTION_NORMALIZE };
  _actionHide = new Set(DEFAULT_ACTION_HIDE);
  _hydrated = false;
}

export function getSourceMapSnapshot() {
  return {
    normalize: { ..._normalize },
    hide: Array.from(_hide),
    action_normalize: { ..._actionNormalize },
    action_hide: Array.from(_actionHide),
    hydrated: _hydrated,
  };
}

export function resolveSourceLabel(value, mode = 'display') {
  if (value == null) {
    return mode === 'canonical' ? null : '';
  }
  const v = String(value).trim();
  if (v === '') {
    return mode === 'canonical' ? null : '';
  }
  if (mode === 'raw') return v;
  if (mode === 'canonical' && _hide.has(v)) return null;
  return _normalize[v] || v;
}

export function resolveActionLabel(value, mode = 'display') {
  if (value == null) {
    return mode === 'canonical' ? null : '';
  }
  const v = String(value).trim();
  if (v === '') {
    return mode === 'canonical' ? null : '';
  }
  if (mode === 'raw') return v;
  if (mode === 'canonical' && _actionHide.has(v)) return null;
  return _actionNormalize[v] || v;
}
